import { CheckCircleFilled } from "@ant-design/icons";
import { Image, List, Typography } from "@p0security/ui";
import * as React from "react";

import { AllIntegrationLogos } from "../../Integrations/IntegrationLogo.tsx";
import LinearGradientComponent from "./LinearGradientComponent";
import {
  StyledCompanyContent,
  StyledIntegrationLogo,
  StyledListContent,
  StyledSectionCol,
} from "./styles";

const { Title, Paragraph } = Typography;

// TODO: we should avoid this hard-coded list here, and instead tag items in the integration registry.
// I'm avoiding doing this work now as I don't grok the purpose of this page nor its design NCB 2026/06/12.
const integrations = [
  "aws",
  "gcloud",
  "azure",
  "snowflake",
  "k8s",
  "postgres",
  "okta",
  "entra-id",
] as const;

const data = [
  "Grant granular least-privileged access to: AWS, Google Cloud, Azure, K8s, Snowflake, PostgreSQL, Okta and more.",
  "Automate access escalations and gain visibility into privileged access.",
  "Conduct an IAM assessment for your AWS, Google Cloud, K8s, Okta, Google Workspace, Entra ID and more.",
];

const CompanySection: React.FC = () => {
  const renderUseCase = React.useCallback(
    (item: string) => (
      <>
        <List.Item>
          <StyledListContent>
            <CheckCircleFilled />
            <Paragraph>{item}</Paragraph>
          </StyledListContent>
        </List.Item>
      </>
    ),
    []
  );
  return (
    <StyledSectionCol xs={0} md={12}>
      <Image preview={false} src={"/main_site_logo.svg"} alt="P0" width={200} />
      <StyledCompanyContent>
        <div className="bg-gradient">
          <LinearGradientComponent />
        </div>
        <Title level={4}>
          Deploy in 5 minutes, no credit card required and immediately:
        </Title>
        <List dataSource={data} size="large" renderItem={renderUseCase} />
        <StyledIntegrationLogo>
          {integrations.map((i) => (
            <div key={i}>{AllIntegrationLogos[i]}</div>
          ))}
        </StyledIntegrationLogo>
      </StyledCompanyContent>
    </StyledSectionCol>
  );
};

export default CompanySection;
